// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"59":"e7ee4cff","488":"6b703efb","725":"cbbc8e76"}[chunkId] + ".chunk.js");